import { render, staticRenderFns } from "./StudentSidebar.vue?vue&type=template&id=57e4940e&scoped=true&lang=pug&"
import script from "./StudentSidebar.vue?vue&type=script&lang=ts&"
export * from "./StudentSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./StudentSidebar.vue?vue&type=style&index=0&id=57e4940e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e4940e",
  null
  
)

export default component.exports